import React, { useEffect } from 'react';
import { GetStaticPropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useAppContext } from '@context/AppContext';

function Custom500() {
  const { authenticateFromCache } = useAppContext();

  useEffect(() => {
    authenticateFromCache();
  }, [authenticateFromCache]);

  return <h1>500 - Something went wrong</h1>;
}

export async function getStaticProps({ locale, defaultLocale }: GetStaticPropsContext) {
  return {
    props: {
      ...(await serverSideTranslations(locale || defaultLocale, ['navbar', 'footer'])),
    },
  };
}

export default Custom500;
